export default __webpack_public_path__ + "static/media/footer-bg-map.ada85800.png";